import {
  animate,
  AnimationEvent,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  EventEmitter,
  Inject,
  signal
} from '@angular/core';
import { BottomSheetRef } from '../../../../shared/src/components/bottom-sheet/bottom-sheet-ref';
import { BOTTOM_SHEET_DATA } from '../../../../shared/src/components/bottom-sheet/bottom-sheet-tokens';
import { AppInstallComponent } from './app-install.component';

@Component({
  selector: 'app-install-bottom-sheet',
  standalone: true,
  imports: [CommonModule, AppInstallComponent],
  template: `
    <div class="content">
      <app-install (onLink)="close()"></app-install>
      <button class="btn-close" tabindex="-1" (click)="close()" aria-label="Close"></button>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
      max-height: 80vh;
      border: 1px solid var(--cui-border-color-translucent);
      border-bottom: none;
      border-radius: 6px 6px 0 0;
    }
    .content {
      position: relative;
      padding: 20px 5px 5px;
      overflow-y: auto;
      background-color: #CEE6F2;
    }
    .btn-close {
      position: absolute;
      top: 4px;
      right: 4px;
      width: 32px;
      height: 32px;
      background: transparent;
      border: none;
      cursor: pointer;
      font-size: 24px;
      line-height: 32px;
      padding: 0;
    }
    .btn-close::before,
    .btn-close::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 20px;
      height: 2px;
      background: #333;
    }
    .btn-close::before { transform: translate(-50%, -50%) rotate(45deg); }
    .btn-close::after { transform: translate(-50%, -50%) rotate(-45deg); }
  `],
  animations: [
    trigger('slideUpDown', [
      transition('void => open', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('{{duration}}ms ease-out', style({ transform: 'translateY(0)', opacity: 1 })),
      ]),
      transition('open => closed', [
        animate('{{duration}}ms ease-in', style({ transform: 'translateY(100%)', opacity: 0 })),
      ]),
      // Optional: prevent flicker on entry
      transition(':enter', [style({ visibility: 'visible' })]),
    ]),
  ],
  host: {
    '[@slideUpDown]': 'animationTrigger()',
    '(@slideUpDown.done)': 'onAnimationDone($event)',
    '[style.visibility]': 'isInitialized() ? "visible" : "hidden"',
  },
})
export class AppInstallBottomSheetComponent {
  private state = signal<'open' | 'closed'>('open');
  private duration = signal<number>(300);
  isInitialized = signal(false);

  animationTrigger = computed(() => ({
    value: this.state(),
    params: { duration: this.duration() },
  }));

  onClose = new EventEmitter<void>();
  onClosed = new EventEmitter<void>();

  constructor(
    public bottomSheetRef: BottomSheetRef<string>,
    @Inject(BOTTOM_SHEET_DATA) public data: any
  ) {
    this.duration.set(this.data?.animationDuration || 300);
    // ensure entry animation runs by delaying initialization
    setTimeout(() => this.isInitialized.set(true), 0);
  }

  close() {
    this.onClose.emit();
    this.state.set('closed');
  }

  onAnimationDone(event: AnimationEvent) {
    if (event.toState === 'closed') {
      this.onClosed.emit();
    }
  }
}